import { createClient, SupabaseClient } from "@supabase/supabase-js";

// Initialize Supabase client
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  const errorMsg = "Supabase URL or Anon Key is missing from environment variables. Check your .env file.";
  console.error(errorMsg, { url: supabaseUrl, key: !!supabaseAnonKey });
}

let supabase: SupabaseClient<any, "public", any>;
try {
  supabase = createClient(supabaseUrl || "", supabaseAnonKey || "");
} catch (error) {
  console.error("Error initializing Supabase client:", error);
  throw error;
}

export { supabase };
